<script module lang="ts">
  export const contextKey = Symbol('stack-context');
</script>

<script lang="ts">
  import { setContext } from 'svelte';
  import clsx from 'clsx';
  import { getGapClasses, type StackContext, type StackProps } from './types';
  import StackDivider from './StackDivider.svelte';

  let {
    children,
    class: className,
    space = 'gutter',
    center,
    dividers,
    dividerAboveAndBelow,
    action = () => undefined,
    actionArg,
    ...restProps
  }: StackProps = $props();
  const context: StackContext = {
    dividers: () => dividers,
    renderedItems: 0,
  };
  setContext(contextKey, context);

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div
  use:elementAction
  class={clsx(getGapClasses(space), 'flex w-full flex-col', className, center && 'items-center')}
  {...restProps}
>
  {#if dividerAboveAndBelow}
    <StackDivider dividers={context.dividers()} />
  {/if}
  {@render children()}
  {#if dividerAboveAndBelow}
    <StackDivider dividers={context.dividers()} />
  {/if}
</div>
